// Training Club Esportiu Orpí - Data

export const clubData = {
  name: "Training Club Esportiu Orpí",
  tagline: "El teu espai d'entrenament a Carme, Orpí i rodalies",
  description: "Club destinat a l'entrenament lliure per als usuaris de Carme, Orpí i rodalies. Enfocat en l'entrenament de cardio i força.",
  logo: "https://customer-assets-lxgj4vgw.emergentagent.net/job_crossfit-carme/artifacts/ca23a9hp_c5c8faab-4cd2-47e9-ace4-2fa69aa13278.jpg",
  heroImage: "https://customer-assets-lxgj4vgw.emergentagent.net/job_crossfit-carme/artifacts/px6rc8tw_image.png",
  instagram: "https://www.instagram.com/training_clubesportiuorpi/",
  reservationForm: "https://chat.whatsapp.com/JoxaRTAMQvV7Olld4dL7tg?mode=gi_t",
};

export const contactData = {
  address: "C/del Sol 4, Orpí (baixos)",
  phone: "697 377 826",
  phoneContact: "David",
  email: "clubesportiuorpi@hotmail.com",
  hours: "7:00 - 21:00",
  daysOpen: "Dilluns a Diumenge",
  president: "David Borràs Valls",
  role: "President i Responsable del Club",
};

export const pricingData = {
  monthly: {
    price: "35€",
    period: "mensual",
    description: "Quota mensual",
    includes: ["Accés il·limitat", "Classes dirigides", "Empremta d'accés"],
    paymentUrl: "https://pay.sumup.com/b2c/QAAZTOW3",
  },
  trimestralFirstYear: {
    price: "75€",
    period: "trimestre (primer any)",
    description: "Trimestral primer any",
    includes: ["Accés il·limitat", "Classes dirigides", "Empremta d'accés"],
    highlight: true,
    paymentUrl: "https://pay.sumup.com/b2c/QY2V6UN7",
  },
  classesOnly: {
    price: "60€",
    period: "trimestre",
    description: "Només classes",
    includes: ["2 classes setmanals", "Sense empremta"],
    note: "Sense accés lliure al gimnàs",
    paymentUrl: "https://pay.sumup.com/b2c/QV39HN7M",
  },
  oneClassWeekly: {
    price: "55€",
    period: "trimestre",
    description: "1 classe setmanal",
    includes: ["1 classe per setmana", "Sense empremta"],
    note: "Sense accés lliure al gimnàs",
    paymentUrl: "https://pay.sumup.com/b2c/QJ2MZKDB",
  },
  veteran: {
    price: "65€",
    period: "trimestre",
    description: "Socis +1 any antiguitat",
    includes: ["Accés il·limitat", "Classes dirigides", "Empremta d'accés"],
    paymentUrl: "https://pay.sumup.com/b2c/QKGBYP32",
  },
  family3: {
    price: "165€",
    pricePerPerson: "55€",
    period: "trimestre",
    description: "Familiar 3 persones",
    includes: ["Accés il·limitat per 3 persones", "Classes dirigides", "Empremta d'accés"],
    paymentUrl: "https://pay.sumup.com/b2c/QAGBA9FO",
  },
  family4: {
    price: "200€",
    pricePerPerson: "50€",
    period: "trimestre",
    description: "Familiar 4 persones",
    includes: ["Accés il·limitat per 4 persones", "Classes dirigides", "Empremta d'accés"],
    paymentUrl: "https://pay.sumup.com/b2c/QBK5L3W4",
  },
  singleEntry: {
    price: "4€",
    description: "Entrada lliure",
    includes: ["Accés 1 dia"],
    note: "Màxim 4 entrades al mes. A partir de la 5ena hauràs d'abonar la mensualitat o el trimestre corresponent.",
    paymentUrl: "https://pay.sumup.com/b2c/QJQ97TWT",
  },
  pack5: {
    price: "15€",
    description: "Pack 5 visites",
    includes: ["5 entrades"],
    note: "S'han de gastar durant el mateix mes de la compra.",
    paymentUrl: "https://pay.sumup.com/b2c/Q2AUCN7G",
  },
  pack6months: {
    price: "120€",
    period: "6 mesos",
    description: "Pack 6 mesos",
    includes: ["Accés il·limitat 6 mesos", "Classes dirigides"],
    paymentUrl: "https://pay.sumup.com/b2c/QBYNKJW5",
  },
  pack12months: {
    price: "200€",
    period: "12 mesos",
    description: "Pack 12 mesos",
    includes: ["Accés il·limitat 12 mesos", "Classes dirigides"],
    highlight: true,
    paymentUrl: "https://pay.sumup.com/b2c/QBY3XCF3",
  },
};

export const reto5Data = {
  title: "RETO 5",
  subtitle: "L'entrenament per lliure al Training Club Esportiu",
  description: "Un entrenament intens amb l'objectiu de completar-lo el més ràpid possible. Prepara't, posa el cronòmetre en marxa i supera el teu millor temps!",
  exercises: [
    { reps: "500", name: "Salts a corda", detail: null },
    { reps: "50", name: "Salts al caixó", detail: "Nivell més baix" },
    { reps: "50", name: "Elevacions de genolls a les paral·leles", detail: "Amb pilota medicinal de 4 kg. La ròtula ha de superar l'alçada del manillar" },
    { reps: "50", name: "Esquats", detail: "Fins als 90°, sense pes" },
    { reps: "50", name: "Squat jumps", detail: null },
    { reps: "50", name: "Burpees", detail: "El pit o l'abdomen ha de tocar el terra · Salt vertical i palmada per sobre del cap · Repetició completa" },
    { reps: "5 KM", name: "Bicicleta Kaiser M3", detail: "Resistència lliure · Les dues mans sempre al manillar · Per eixugar-se la suor es pot deixar només una mà · En cap cas les dues mans fora" },
  ],
  material: [
    "Tot el material s'ha d'anar a buscar un cop comença el Reto 5.",
    "No es pot deixar el material preparat abans de començar.",
    "Quan s'acaba un exercici que requereix material, s'ha de tornar a deixar al seu lloc.",
    "Un cop deixat el material, cal anar a buscar el següent material.",
    "No es pot acumular ni deixar preparat material dels exercicis posteriors.",
  ],
  timeControl: [
    "El cronòmetre comença en el moment d'iniciar el Reto 5.",
    "Quan hagis completat tots els exercicis i els 5 km de bicicleta, atura el cronòmetre i apunta el teu temps a la pissarra.",
  ],
};

export const paymentSchedule = {
  title: "Pagaments Trimestrals",
  periods: [
    { period: "Setembre-Octubre", dates: "27 setembre - 5 octubre" },
    { period: "Desembre-Gener", dates: "27 desembre - 5 gener" },
    { period: "Març-Abril", dates: "27 març - 5 abril" },
    { period: "Juny-Juliol", dates: "27 juny - 5 juliol" },
  ],
  latePaymentNote: "Totes aquelles persones que paguin fora de termini o es donin de baixa de soci se'ls aplicarà la quota trimestral primer any de 75€",
};

export const equipmentData = {
  freeWeights: {
    name: "Pes Lliure",
    items: [
      "Manuelles de 1 a 25 kg",
      "Discos olímpics",
      "Barres rectes i corbades",
    ],
  },
  machines: {
    name: "Màquines",
    items: [
      "Jalón dorsal",
      "Dominades assistides",
      "Tríceps assistits",
      "Multicadera",
      "Hip thrust",
      "Hiperextensions lumbars",
      "Multipower",
      "Peck deck / Peck fly",
      "Màquina d'espatlla lateral",
      "Màquina de quadríceps",
      "Màquina de bíceps femoral",
    ],
  },
  cardio: {
    name: "Cardio",
    items: [
      "Fins a 7 bicicletes de ciclisme indoor",
      "Cinta de córrer",
      "Elíptica",
    ],
  },
  functional: {
    name: "Entrenament Funcional",
    items: [
      "Cajón",
      "Bosu",
      "Kettlebells",
      "TRX",
      "Pilota medicinal",
    ],
  },
};

export const spinfitData = {
  name: "SPINFIT",
  emoji: "🚴‍♀️🔥",
  tagline: "NEIX SPINFIT",
  description: "Una nova classe que combina Spinning + Fit en una mateixa sessió!",
  howItWorks: [
    "El grup es dividirà en dues parts: una meitat començarà fent Spinning i l'altra meitat farà Fit.",
    "A meitat de la classe, farem el relleu i canviarem d'activitat.",
    "Així, durant la sessió, tothom farà 50% Spinning i 50% Fit, combinant cardio, força, resistència i exercicis funcionals.",
  ],
  taglineFinal: "Dues disciplines. Una sola classe. SPINFIT.",
};

export const classesData = [
  {
    id: "spinfit-dimarts",
    name: "SPINFIT",
    day: "Dimarts",
    time: "19:30 - 20:30",
    duration: "60 min",
    maxCapacity: 15,
    instructor: "David",
    description: "Combinació de Spinning + Fit. Cardio, força i resistència en una sola classe!",
    isNew: true,
  },
  {
    id: "dirigida-dijous",
    name: "Classe Dirigida",
    day: "Dijous",
    time: "19:00 - 20:00",
    duration: "60 min",
    maxCapacity: 15,
    instructor: "David",
    types: ["Body Pump", "GAC", "Aeròbic"],
    description: "Rotació: 2 mesos Body Pump, 2 mesos GAC, 2 mesos Aeròbic. Abril: Mix de les tres. Maig: Caminades",
    rotation: {
      bodyPump: "2 mesos",
      gac: "2 mesos",
      aerobic: "2 mesos",
      april: "Mix de les tres disciplines",
      may: "Caminades populars",
    },
  },
];

export const scheduleData = {
  period: "D'octubre a maig",
  days: ["Dimarts", "Dijous"],
  note: "Classes amb aforament limitat a 15 persones. Reserva necessària.",
};

export const seniorCareData = {
  title: "Atenció i consells personalitzats",
  description: "Grups reduïts de màxim 4 persones per a majors de 60 anys, o per a gent gran amb dificultat a l'hora de fer servir les màquines o que necessiten atenció específica.",
  day: "Dimarts",
  time: "18:45 - 19:15",
  maxCapacity: 4,
};

export const specialActivities = {
  may: {
    name: "Caminades Populars",
    description: "Al mes de maig, tots els dijous organitzem caminades",
    open: "Obert per socis i no socis",
    day: "Dijous",
    month: "Maig",
  },
};

export const facilityImages = [
  {
    id: "gym-1",
    url: "https://customer-assets-lxgj4vgw.emergentagent.net/job_crossfit-carme/artifacts/px6rc8tw_image.png",
    alt: "Zona d'entrenament principal",
  },
  {
    id: "gym-2",
    url: "https://customer-assets-lxgj4vgw.emergentagent.net/job_crossfit-carme/artifacts/8i2zam3d_image.png",
    alt: "Zona de màquines i pes lliure",
  },
];

export const benefitsData = [
  {
    id: "schedule",
    icon: "Clock",
    title: "Horari Ampli",
    description: "Obert de 7:00 a 21:00, tots els dies de la setmana",
  },
  {
    id: "access",
    icon: "Fingerprint",
    title: "Accés amb Empremta",
    description: "Entra al gimnàs de forma ràpida i segura amb la teva empremta",
  },
  {
    id: "classes",
    icon: "Users",
    title: "Classes Dirigides",
    description: "Spinning, funcional, GAC, tabata, aeròbic i power pump",
  },
  {
    id: "equipment",
    icon: "Dumbbell",
    title: "Equipament Complet",
    description: "Tot el que necessites per entrenar: cardio, força i funcional",
  },
  {
    id: "price",
    icon: "Euro",
    title: "Preu Assequible",
    description: "Només 60€ al trimestre per socis actuals",
  },
  {
    id: "community",
    icon: "Heart",
    title: "Ambient Familiar",
    description: "Club local per la comunitat de Carme, Orpí i rodalies",
  },
];
